import { CRISP_WEBSITE_ID } from "./config";
import { User } from "./user/userModel";

declare global {
  interface Window {
    $crisp?: unknown[];
    CRISP_WEBSITE_ID?: string;
  }
}

let injected = false;

/**
 * Injects the Crisp client. Idempotent: the chatbox is a page-wide singleton
 * that cannot be unloaded, so callers hide it instead of removing it.
 */
export function loadCrisp() {
  if (injected || !CRISP_WEBSITE_ID) return;
  injected = true;

  window.$crisp = [];
  window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

  const script = document.createElement("script");
  script.src = "https://client.crisp.chat/l.js";
  script.async = true;
  // NOTE: These routes are served with `Cross-Origin-Embedder-Policy:
  // require-corp` (see vite.config.ts). It works because client.crisp.chat and
  // image.crisp.chat both answer with `Cross-Origin-Resource-Policy:
  // cross-origin` — if Crisp ever drops that header the widget goes silently
  // blank instead of erroring.
  document.head.appendChild(script);
}

export function showCrisp() {
  window.$crisp?.push(["do", "chat:show"]);
}

export function hideCrisp() {
  window.$crisp?.push(["do", "chat:hide"]);
}

export function setCrispUser(user: User) {
  window.$crisp?.push(["set", "user:email", [user.email]]);
  window.$crisp?.push([
    "set",
    "user:nickname",
    [`${user.firstname} ${user.lastname}`],
  ]);
  if (user.phoneNumber)
    window.$crisp?.push(["set", "user:phone", [user.phoneNumber]]);
  if (user.organization?.legalName)
    window.$crisp?.push(["set", "user:company", [user.organization.legalName]]);
  // Lets the support agent jump straight to the right account in the back-office
  window.$crisp?.push([
    "set",
    "session:data",
    [[["user_id", String(user.id)]]],
  ]);
}

/** Drops the visitor session so the next user does not inherit the thread. */
export function resetCrisp() {
  window.$crisp?.push(["do", "session:reset"]);
}
